module.exports = __webpack_public_path__ + "img/KB.a52e2dbf.png";